import React, { useState } from "react";
import {Autocomplete, CircularProgress, InputAdornment, TextField} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

const AutocompleteValidatedTextField = ({
                                            id,
                                            options,
                                            label,
                                            onChange,
                                            setActiveForm,
                                            isSubmitting,
                                            initialValue,
                                            infoAdornment,
                                            width, 
                                            required, 
                                            size = "medium",
                                            loadingStatus }) => 
{
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState(false);
    const handleChange = (e, newValue) => {
        const errorMessage = newValue === null ? "Please choose an option." : false;
        setValue(newValue);
        setError(errorMessage);
        onChange(!errorMessage);
        setActiveForm(prevState => ({
            ...prevState,
            [id]: newValue?.key,
        }));
    };
    
    return infoAdornment === null ? (
        <Autocomplete
            id={id}
            options={options}
            disabled={isSubmitting}
            getOptionLabel={(option) => option.name || ''}
            value={value || null}
            onChange={handleChange}
            noOptionsText={loadingStatus === 'failed' ? 'Failed to load clients. Please try again later.' : 'No options found.'}
            isOptionEqualToValue={(option, value) => option.key === value.key}
            loading={loadingStatus === 'loading' ?? false}
            renderInput={(params) => (
                <TextField {...params}
                           error={!!error}
                           helperText={error ? error : " "}
                           label={label}
                           size={size}
                           required={required ?? false}
                           sx={{ width: width ?? {xs: 200, sm: 250, md: 300} }}
                />
            )}
            sx={{ display: 'flex', width: width ?? {xs: 200, sm: 250, md: 300} }}
        />
    ) : (
        <Autocomplete
            id={id}
            options={options}
            disabled={isSubmitting}
            getOptionLabel={(option) => option.name || ''}
            value={value || null}
            onChange={handleChange}
            noOptionsText={loadingStatus === 'failed' ? 'Failed to load clients. Please try again later.' : 'No options found.'}
            isOptionEqualToValue={(option, value) => option.key === value.key}
            renderInput={(params) => (
                <TextField {...params}
                           error={!!error}
                           helperText={error ? error : " "}
                           label={label}
                           required={required ?? false}
                           size={size}
                           sx={{ display: 'flex', width: width ?? {xs: 200, sm: 250, md: 300} }}
                           slotProps={{
                               input: { 
                                   ...params.InputProps,
                                   endAdornment: loadingStatus === 'loading' 
                                       ? <React.Fragment>
                                           {loadingStatus === 'loading' 
                                               ? <CircularProgress color="inherit" size={20} /> 
                                               : null}
                                           {params.InputProps.endAdornment}
                                   </React.Fragment>
                                       : <>
                                           {params.InputProps.endAdornment}
                                           <InputAdornment position="end">
                                               <Tooltip disableFocusListener title={infoAdornment}>
                                                   <InfoIcon />
                                               </Tooltip>
                                           </InputAdornment>
                                       </> }
                           }}
                />
            )}
            sx={{ display: 'flex', width: width ?? {xs: 200, sm: 250, md: 300} }}
        />
    );
};

export default AutocompleteValidatedTextField;